import { PaginationData } from '../models/paginationData';
import {
    PushHistoryItem,
    PushSendResult,
    PushTargetPreview,
    PushTargetType,
} from '../types/push';
import { apiClient } from './axios';

export interface SendPushToUserRequest {
    title: string;
    body: string;
    imageUrl?: string;
}

export interface SendPushToGroupRequest {
    targetType: PushTargetType;
    title: string;
    body: string;
    imageUrl?: string;
}

export const pushApi = {
    sendToUser: (userId: number, data: SendPushToUserRequest) =>
        apiClient.post<PushSendResult>(`/admin/push/send/user/${userId}`, data),

    sendToGroup: (data: SendPushToGroupRequest) =>
        apiClient.post<PushSendResult>('/admin/push/send/group', data),

    getHistories: async (page: number, size: number) => {
        const response = await apiClient.get<PaginationData<PushHistoryItem>>('/admin/push/histories', {
            page: page - 1,
            size,
        });
        return {
            ...response,
            content: response.content ?? [],
        };
    },

    getTargetPreview: (targetType: PushTargetType) =>
        apiClient.get<PushTargetPreview>('/admin/push/preview/count', {
            targetType,
        }),
};
